import React from 'react';
import styled from 'styled-components';

import { Label } from '../Label';

interface IProps {
    className?: string;
    leftLabel: string;
    rightLabel: string;
}

const BaseLabels: React.FC<IProps> = ({ className, leftLabel, rightLabel }) => (
    <div className={className}>
        <Label>{leftLabel}</Label>
        <Label>{rightLabel}</Label>
    </div>
);

export const Labels = styled(BaseLabels)`
    display: flex;
    justify-content: space-between;
    position: absolute;
    width: 100%;
    top: -18px;
    z-index: 2;
`;
